import { Box, Button, Flex, Image, Stack, Text, VStack } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { SmallBreak } from "../helpers";

const Events = () => {
  const router = useRouter();
  return (
    <Box width="full" bgColor={"rgba(240, 237, 236, 0.2)"}>
      <Flex
        py={{ lg: "100px", base: "64px" }}
        gap={{ xl: "100px", lg: "54px", base: "40px" }}
        align={"center"}
        justify={"start"}
        px={{ xl: "160px", lg: "24px", base: "16px" }}
        fontFamily={"Inter"}
        direction={{ xl: "row", lg: "column-reverse", base: "column-reverse" }}
        maxWidth={"1440px"}
        mx="auto"
      >
        <Stack
          spacing={{ xl: "16px", lg: "24px", base: "24px" }}
          align={"start"}
          direction={{ xl: "column", lg: "row", base: "column" }}
        >
          <Image
            src="images/events/video1.webp"
            alt=""
            loading="lazy"
            objectFit="cover"
            w={{ base: "343px", lg: "476px", xl: "492px" }}
            h={{ base: "193.11px", lg: "267.99px", xl: "100%" }}
          />
          <Image
            src="images/events/video2.webp"
            alt=""
            loading="lazy"
            objectFit="cover"
            w={{ base: "343px", lg: "476px", xl: "492px" }}
            h={{ base: "193.11px", lg: "267.99px", xl: "100%" }}
          />
        </Stack>

        <VStack
          align={"start"}
          width={{ xl: "514px", lg: "879px", base: "343px" }}
          mr={{ lg: "auto", base: "none" }}
        >
          <Text
            mb="16px"
            color={"rgba(13, 48, 80, 0.8)"}
            fontSize={{ lg: "18px", base: "14px" }}
            lineHeight={{ lg: "18px", base: "14px" }}
            letterSpacing={"0.05em"}
            textTransform={{ base: "uppercase" }}
          >
            Learn Something New and Exciting
          </Text>
          <Text
            mb="24px"
            color={"#0D3050"}
            fontFamily={"Georgia"}
            fontSize={{ lg: "56px", base: "44px" }}
            lineHeight={{ lg: "64px", base: "48px" }}
            letterSpacing={{ base: "-0.02em" }}
          >
            Events at Advante
          </Text>
          <Text
            color={"rgba(13, 48, 80, 0.8)"}
            fontSize={{ lg: "20px" }}
            lineHeight={{ lg: "32px" }}
            letterSpacing={{ xl: "unset", lg: "unset", base: "0.02em" }}
            minWidth={{ xl: "528px" }}
            w={"full"}
          >
            Our coaching services and events are designed to provide you with the knowledge, skills,
            and support you need to succeed in your career. Discover the events below and join us
            for an unforgettable experience that can help you unlock new opportunities and propel
            your career forward. We look forward to welcoming you to our community of <SmallBreak />{" "}
            driven professionals!
          </Text>
          <Flex justify={"start"} pt="32px" width={{ base: "full" }}>
            <Button
              bgColor="#F9D209"
              py={{ lg: "14px" }}
              px={{ lg: "20px" }}
              w={{ lg: "unset", base: "full" }}
              onClick={() => router.push("/events")}
            >
              View our events
            </Button>
          </Flex>
        </VStack>
      </Flex>
    </Box>
  );
};

export default Events;
